import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const serviceDeskProductsRoute: InvariantJiraRoute = {
	name: 'servicedesk-customer-service-products',
	path: '/jira/servicedesk/projects/:projectKey/products',
	exact: true,
};
